import { startsWith } from 'lodash';
import { contentTypeOf, resolveFileSrc } from 'app/main/apps/common/fileSource';

/**
 * PGSS-5476: this built its src as `data:<type>;base64,<data>` directly. Once the packing checklist
 * began sending a signed link instead of the bytes, `data` was undefined and every image opened as
 * `base64,undefined` -- a blank viewer, with nothing in the console to say why.
 *
 * Resolving through the shared helper means it takes the link when there is one and the bytes when
 * there are not, so every other caller keeps working unchanged.
 */

const ImageViewerWindow = (image) => {
  const newWindow = window.open('', '_blank');
  newWindow.document.write(`
    <html>
      <head>
        <title>Image Viewer</title>
        <style>
          html, body {
            height: 100%;
            margin: 0;
            padding: 0;
          }
          body {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: black;
          }
          img {
            width: 100vw;
            height: 100vh;
            object-fit: contain;
        }
        </style>
      </head>
      <body>
      ${image.map((media, index) => `
  ${contentTypeOf(media)
      ? `<img 
        src="${startsWith(contentTypeOf(media), 'image/') ?
        resolveFileSrc(media) :
        'assets/icons/pdf.png'}" 
        class="max-w-none w-auto h-full" 
        alt="attachment" 
      />`
      : `<img 
        src="${startsWith(media.url, 'data:image/') ?
        media.url :
        'assets/icons/pdf.png'}" 
        class="max-w-none w-auto h-full" 
        alt="attachment" 
      />`
    }
`)}

       
      </body>
    </html>
  `);

  return null;
};

export default ImageViewerWindow;
